import { Component } from '@angular/core';

import { SliderComponent } from '../../slider.shared.component';

@Component({
    selector: 'shared-slider-side-counter',
    templateUrl: './slider-side-counter.shared.component.html',
    styleUrls: ['./slider-side-counter.shared.component.scss']
})
export class SliderSideCounterComponent extends SliderComponent {
}
